'use strict';
import Vue from 'vue';
import NProgress from 'nprogress';
import axios from 'axios';
import store from '@store';
import router from '@router';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
};

const _axios = axios.create(config);
// before a request is made start the nprogress
_axios.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    NProgress.done();
    // Do something with response data
    return response;
  },
  function (error) {
    NProgress.done();
    const { status = 500 } = error.response ? error.response : {};
    let errorMessage = `Maaf!, Ada kesalahan pada data yang membuat aplikasi tidak berjalan.<br/>Silakan memuat ulang halaman`;
    let conectionLost = `Terjadi kegagalan koneksi, pastikan Anda terhubung internet.<br/>Silakan mencoba kembali.`;
    let message =
      (error.response && error.response.data && error.response.data.title) ||
      (status === 500 ? errorMessage : conectionLost);

    const statusForNotify = [400, 401, 404, 405, 422, 500, 501, 502, 503, 504, 520, 521];
    if (statusForNotify.includes(status)) {
      if (status !== 401) {
        Vue.prototype.$error(message || (status === 500 ? errorMessage : conectionLost));
      } else {
        if (store.getters['auth/loggedIn']) {
          Vue.prototype.$error('Mohon maaf, sesi Anda telah habis. Silakan melakukan relogin!', [
            {
              label: 'Login',
              event: () => {
                // 401 redirect ke auth login
                store.dispatch('auth/logout').then(() => {
                  const isUcm = store.getters['auth/isUcm'];
                  if (isUcm) window.location.href = process.env.VUE_APP_API_URL + `/auth/cas`;
                  else router.push({ name: 'login' });
                });
              },
            },
          ]);
          return;
        }
      }
    }

    // Do something with response error
    return Promise.reject(message || (status === 500 ? errorMessage : conectionLost));
  }
);

export default _axios;
